<template>
  <v-row>
    <v-col cols="12">
      <v-text-field v-model="formData.name" label="Client Name"></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="4">
      <v-text-field v-model="formData.liason" label="Liason"></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="4">
      <v-text-field
        v-model="formData.email"
        :rules="emailRules"
        label="E-mail"
        required
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="4">
      <v-text-field
        v-model="formData.phone"
        label="Phone"
        v-mask="phoneMask"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ClientForm",
  props: ["clientid", "data", "savingForm", "action"],
  data: () => ({
    formData: {
      name: null,
      liason: null,
      email: null,
      phone: null
    },
    phoneMask: "###-###-####",
    emailRules: [v => v == null || /.+@.+/.test(v) || "E-mail must be valid"]
  }),
  computed: {
    validForm() {
      return (
        this.formData.name !== null &&
        this.formData.name !== "" &&
        this.formData.name !== undefined &&
        this.formData.liason !== undefined &&
        this.formData.email !== null &&
        this.formData.email !== "" &&
        this.formData.email !== undefined &&
        /.+@.+/.test(this.formData.email) &&
        this.formData.phone !== null &&
        this.formData.phone !== "" &&
        this.formData.phone !== undefined &&
        (this.action != "Edit" ||
          this.formData.name != this.data.name ||
          this.formData.liason != this.data.liason ||
          this.formData.email != this.data.email ||
          this.formData.phone != this.data.phone)
      );
    },
    userAdmin() {
      if (this.loggedInUser.type == "Admin") {
        return true;
      } else {
        return false;
      }
    },
    loggedInUser() {
      return this.$store.getters.getLoggedInUser;
    }
  },
  watch: {
    savingForm(newVal, oldVal) {
      if (newVal == true && oldVal == false) {
        this.$emit(
          "loading",
          this.action == "Delete"
            ? "Deleting Client"
            : this.action + "ing Client"
        );

        if (this.action == "Add") {
          this.addClient();
        } else if (this.action == "Edit") {
          this.editClient();
        } else if (this.action == "Delete") {
          this.deleteClient();
        }
      }
    },
    validForm(val) {
      if (val == true) {
        this.$emit("valid-form", true);
      } else {
        this.$emit("valid-form", false);
      }
    }
  },
  methods: {
    getChangedClientData() {
      let changedData = {};
      let oldData = this.data;
      for (var key in this.formData) {
        if (oldData[key] != this.formData[key]) {
          changedData[key] = this.formData[key];
        }
      }

      return changedData;
    },
    editClient() {
      let self = this;
      if (self.userAdmin == true) {
        self.$store
          .dispatch("editClient", {
            clientId: this.data.id,
            changedData: self.getChangedClientData()
          })
          .then(result => {
            if (result.success != true) {
              this.$emit("error", result.data.error.message);
            } else {
              this.$emit("success", "Successfully edited client!");
              this.$emit("update-table", {
                action: "edit",
                item: result.data.Attributes
              });
            }
          });
      } else {
        self.$emit("error", "Unable to edit client.");
      }
    },
    deleteClient() {
      let self = this;
      // if(self.userAdmin == true)
      // {
      //   self.$store.dispatch("deleteClient", self.formData.id).then(result => {
      //     if (result.success != true) {
      //       this.$emit("error", result.data.error.message);
      //     } else {
      //       this.$emit("success", "Successfully deleted client!");
      //       this.$emit("update-table", {
      //         action: "delete",
      //         item: self.formData.id
      //       });
      //     }
      //   });
      // }
      // else{
      self.$emit("error", "Unable to delete client.");
      // }
    },
    addClient() {
      let self = this;
      self.$store.dispatch("addClient", this.formData).then(result => {
        if (result.success != true) {
          this.$emit("error", result.data.error.message);
        } else {
          this.$emit("success", "Successfully added client!");
          this.$emit("update-table", { action: "add", item: result.data });
        }
      });
    }
  },
  mounted() {
    if (this.data != null) {
      this.formData = JSON.parse(JSON.stringify(this.data));
    }
  }
};
</script>

<style>
.forceuppercase input {
  text-transform: uppercase;
}
</style>
